<template>
  <div class="content">
    <img :src="takeOutImagePath" class="key-visual"  alt=""/>
    <p class="heading">
      香の川製麺アプリから<br>
      テイクアウト注文ができます！
    </p>
    <p class="notes">
      ※一部店舗ではテイクアウト販売を行っておりません。<br />
      ※一部店舗及び沖縄県内の店舗では販売商品、<br>販売価格が異なります。
    </p>
    <button class="primary external" @click="openWebOrder">テイクアウトをネット注文する</button>
    <!-- button class="primary external" @click="openStoreSearch">店舗検索</button -->
    <button @click="showUsage">ご利用時の注意点について</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter'
import APIClient, { ErrorCode } from '../api/APIClient'

export default {
  name: 'NetShopTakeOut',
  data() {
    return {
      title: 'テイクアウト',
      webOrderUrl: process.env.VUE_APP_JOYNET_ENDPOINT,
      homeUri: 'frbbscreen://home',
      storeSearchUri: 'frbbscreen://search',
      takeOutImagePath: ''
    }
  },
  created() {
    const accTime = new DateFormatter().format(new Date())
    this.fetchTakeOutImage(accTime)
  },
  methods: {
    ...mapActions('Native', ['actionRequestToken', 'actionRequestExternalLink']),
    openWebOrder() {
      const accTime = new DateFormatter().format(new Date())
      window.receivedToken = async payload => {
        window.receivedToken = null
        const json = JSON.parse(payload)
        await this.encryptUserId(json.user_id, accTime)
      }
      this.actionRequestToken({ apiType: '3', acc_time: accTime })
    },
    async encryptUserId(userId, accTime) {
      const res = await APIClient.postEncryptedUserId(userId, accTime)
      let url = this.webOrderUrl
      if (userId != null && res.status === 200 && res.data.url.length > 0) {
        url = res.data.url
      }
      this.actionRequestExternalLink(url)
    },
    openStoreSearch() {
      this.actionRequestExternalLink(this.webOrderUrl)
    },
    showUsage() {
      this.$emit('showUsage')
    },
    async fetchTakeOutImage(accTime) {
      const res = await APIClient.postFetchTakeOutImage(accTime)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS && res.data.data.takeout_image.length > 0) {
        this.takeOutImagePath = res.data.data.takeout_image
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;

  .key-visual {
    width: 100%;
    margin-bottom: 15px;
  }

  .heading {
    font-size: 15px;
    font-weight: bold;
    color: #66160E;
    margin-bottom: 15px;
  }

  .notes {
    font-size: 11px;
    margin-bottom: 20px;
  }

  button {
    width: 100%;
    height: 44px;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 15px;
    border: 1px solid #602209;
    background: #ffffff;
    color: #602209;

    &.primary {
      color: #ffffff;
      background: #602209;
    }
    &.external {
      background: #602209 url("~@/assets/img/net-shop/open_external.png") no-repeat 98%;
      background-size: 20px;
    }
  }
}

</style>
